import { isFuture, isPast, secondsToMilliseconds } from 'date-fns';

import {
    EpgProgram,
    MixedItem,
    RBProgram,
} from 'store/railsBuilder/reducer.types';

import { VodEditorial } from 'services/data-manager/types';

import getCorrectProgramStartAndEndTime from 'utils/getCorrectProgramStartAndEndTime';
import getDeeplinkItem from 'utils/getDeeplinkItem';
import isValidDeeplinkItem from 'utils/isValidDeeplinkItem';

export default function isValidPastDeeplinkItem(
    item: MixedItem | RBProgram | VodEditorial | EpgProgram | undefined,
): boolean | undefined {
    const deeplink = getDeeplinkItem(item);

    if (!deeplink) {
        return undefined;
    }

    let programStartTime: number | undefined = 0;
    let programEndTime: number | undefined = 0;

    if ((item as MixedItem).startTime && (item as MixedItem).endTime) {
        programStartTime = (item as MixedItem).startTime;
        programEndTime = (item as MixedItem).endTime;
    } else {
        ({ programStartTime, programEndTime } =
            getCorrectProgramStartAndEndTime(item));
    }

    if (!programStartTime || !programEndTime) {
        return undefined;
    }

    if (isFuture(secondsToMilliseconds(programStartTime))) {
        return false;
    }

    if (
        isPast(secondsToMilliseconds(programStartTime)) &&
        isFuture(secondsToMilliseconds(programEndTime))
    ) {
        return false;
    }

    return isValidDeeplinkItem(deeplink);
}
